export default __webpack_public_path__ + "static/media/airpod-right.fae69ecb.png";